import {dom, human, runtime} from './utils-js'

export default {
    dom,
    human,
    runtime,
}